"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.permissionCheckerUtil = exports.isBetaConfig = exports.isInBeta = exports.permissionCheckerFn = exports.hasPermission = exports.abbreviateName = exports.formattedPhoneNumber = exports.disableIconOffsetFn = void 0;
const stringToAvatarLetters_1 = require("../_InternalUtils/stringToAvatarLetters");
/**
 *  If offset is disabled, return an empty string. (No padding).
 *  If icon is "none" return the number 3. This equals to theme.spacing(3)
 *  Else return empty sting.
 */
const disableIconOffsetFn = (disableIconOffset, iconId) => {
    if (disableIconOffset)
        return ""; // If
    if (iconId === "none")
        return 3; // If icon "none", apply "padding-left :theme.spacing(3)"
    return "";
};
exports.disableIconOffsetFn = disableIconOffsetFn;
// Format a Norwegian phone number
//     +4723204741
// --> +47 23 20 47 41
const formattedPhoneNumber = (phoneNumber) => {
    const m = phoneNumber.match(/(\+\d\d)?(\d\d)(\d\d)(\d\d)(\d\d)/);
    if (!m)
        return phoneNumber;
    return m
        .slice(1)
        .filter((x) => x !== undefined)
        .join(" ");
};
exports.formattedPhoneNumber = formattedPhoneNumber;
/**
 * Abbreviates a full name with the format: "First MiddleInitials Last".
 *
 * @param fullname The full name to be abbreviated.
 * @returns The abbreviated full name in the format "First MiddleInitials Last".
 */
const abbreviateName = (fullname) => {
    const normalizedArray = (0, stringToAvatarLetters_1.normalizeNameArray)(fullname);
    if (normalizedArray.length <= 1) {
        // If there's only one name part, return it as is
        return fullname;
    }
    const [firstName, ...middleAndLastNameParts] = normalizedArray;
    const middleNames = middleAndLastNameParts.slice(0, -1);
    const lastName = middleAndLastNameParts[middleAndLastNameParts.length - 1];
    const abbreviatedMiddleNames = middleNames.length > 0 ? `${middleNames.map((name) => name.charAt(0).toUpperCase() + ". ").join("")}` : "";
    return `${firstName} ${abbreviatedMiddleNames}${lastName}`;
};
exports.abbreviateName = abbreviateName;
/**
 * @internal
 * Takes a {@link https://stash.mnemonic.no/projects/PAG/repos/authentication/browse/packages/api/src/%40types/Session.d.ts ISession} and checks if the required `function` exists.
 * If an item does *not* have the properties `requiredPermission` or the `function` exist in the Session, return true, if not, false.
 * For reducing dependencies in this core package, i have redefined a subset if ISession as ISimplifiedSession only containing the properties needed by this function.
 */
const hasPermission = (session, item) => !item?.requiredPermission || session?.functions.some((fn) => fn?.name === item.requiredPermission);
exports.hasPermission = hasPermission;
/**
 * @internal
 * This function takes a list and recursively check if the provided session has the correct permissions.
 */
function permissionCheckerFn(session, list = []) {
    return list
        ?.map((el) => {
        if (!(0, exports.hasPermission)(session, el))
            return null;
        if (el.items) {
            return {
                ...el,
                items: permissionCheckerFn(session, el.items),
            };
        }
        return el;
    })
        .filter(Boolean);
}
exports.permissionCheckerFn = permissionCheckerFn;
/**
 *  @internal
 * Check is the user is in the beta
 */
const isInBeta = (user) => {
    return user?.properties?.["argusmenu.beta"] === "true" && user?.domain?.name === "MNEMONIC";
};
exports.isInBeta = isInBeta;
/**
 * @internal
 * Typeguard to check if a config in a beta variant.
 */
function isBetaConfig(config) {
    return config.isBeta;
}
exports.isBetaConfig = isBetaConfig;
/**
 * This utility is designed to work together with `getMenuConfig()`, but can be used standalone, as long the input follows the same structure.
 *  It return a new config file where all elements not passing the permission check is filtered out.
 * ```ts
 * const filteredConfig = permissionCheckerUtil(session, getMenuConfig())
 * ```
 */
function permissionCheckerUtil(session, config) {
    if (isBetaConfig(config)) {
        return { ...config, items: permissionCheckerFn(session, config.items) };
    }
    return {
        ...config,
        nav: {
            ...config?.nav,
            items: permissionCheckerFn(session, config?.nav?.items),
        },
        userMenu: {
            ...config?.userMenu,
            items: permissionCheckerFn(session, config?.userMenu?.items),
        },
    };
}
exports.permissionCheckerUtil = permissionCheckerUtil;
